<template>
  <span
    class="role-rotator inline-block align-bottom max-w-full min-w-0"
    :style="rotatorStyle"
    aria-live="polite"
  >
    <Transition :name="transitionName" mode="out-in">
      <span
        :key="currentRole"
        class="role-rotator__word inline-block max-w-full break-words bg-gradient-to-r from-primary via-violet-500 to-indigo-400 bg-clip-text text-transparent"
      >
        {{ currentRole }}
      </span>
    </Transition>
  </span>
</template>

<script>
export default {
  name: 'RoleRotator',
  props: {
    roles: {
      type: Array,
      required: true,
    },
    interval: {
      type: Number,
      default: 3200,
    },
  },
  data() {
    return {
      index: 0,
      timer: null,
      prefersReducedMotion: false,
    }
  },
  computed: {
    currentRole() {
      return this.roles[this.index] || ''
    },
    minWidthCh() {
      const longest = this.roles.reduce((max, role) => Math.max(max, role.length), 0)
      return longest + 0.5
    },
    transitionName() {
      return this.prefersReducedMotion ? 'role-fade' : 'role-slide'
    },
    rotatorStyle() {
      return { '--role-min': `${this.minWidthCh}ch` }
    },
  },
  mounted() {
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (this.roles.length > 1 && !this.prefersReducedMotion) {
      this.start()
    }
  },
  beforeUnmount() {
    this.stop()
  },
  methods: {
    start() {
      this.stop()
      this.timer = window.setInterval(() => {
        this.index = (this.index + 1) % this.roles.length
      }, this.interval)
    },
    stop() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
  },
}
</script>

<style scoped>
.role-rotator {
  min-height: 1.15em;
}

@media (min-width: 640px) {
  .role-rotator {
    min-width: var(--role-min, auto);
  }
}

.role-slide-enter-active,
.role-slide-leave-active {
  transition:
    opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1),
    transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.role-slide-enter-from {
  opacity: 0;
  transform: translateY(0.65em);
}

.role-slide-leave-to {
  opacity: 0;
  transform: translateY(-0.65em);
}

.role-fade-enter-active,
.role-fade-leave-active {
  transition: opacity 0.25s ease;
}

.role-fade-enter-from,
.role-fade-leave-to {
  opacity: 0;
}
</style>
